import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import NoLocationsIcon from 'components/Icons/NoLocationsIcon'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('ordering_management.empty_state')

const EmptyState: React.FC = () => {
  const [css] = useStyletron()

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.iconContainer)}>
        <NoLocationsIcon />
      </div>

      <Text.Header3 className={css(styles.title)}>{t('title')}</Text.Header3>

      <Text.BodyText2 color="grey70" className={css(styles.description)}>
        {t('description')}
      </Text.BodyText2>

      <Button onClick={handleRefresh} type="button">
        {t('refresh')}
      </Button>
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
    padding: '48px 24px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: '#F5F5F5',
    marginBottom: '32px',
  },
  title: {
    marginBottom: '16px',
    textAlign: 'center' as const,
  },
  description: {
    textAlign: 'center' as const,
    marginBottom: '48px',
    maxWidth: '500px',
  },
}

export default EmptyState
